/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block}.dialog__actions[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between;align-items:center}.dialog__actions--compact[_ngcontent-%COMP%]{justify-content:flex-end}@media (min-width:480px){[_nghost-%COMP%]{min-width:320px}}"];
export { styles as styles };
